<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm6 md4>
      <v-card >
        <v-toolbar dark color="primary">
          <v-toolbar-title>Directors Obligation Acknowledgement</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                I have read and understand the Reno Rodeo Association's <b>Confidentiality Agreement and Conflict of Interest Policies</b>. I agree to abide by the
                terms regarding confidentiality and conflicts of interest as outlined in these policies, acting in the best interest of the Reno Rodeo Association.
              </v-flex>
              <v-flex xs12>
                A conflict of interest is defined as an interest that might affect, or might reasonably appear to affect, the judgment or conduct of any director
                in an adverse manner to the interests of RRA.
              </v-flex>
              <v-flex xs12>
                <a href="https://front.rrride.com/api/documents/Confidentiality_Agreement.pdf" target="_blank">Confidentiality Agreement and Conflict of Interest Policies</a>
              </v-flex>
              <v-flex xs12>
                By signing below, I affirm that:
                <ol>
                <li>I have read and understand the Confidentiality Agreement and Conflict of Interest Policies;</li>
                <li>I agree to comply with these policies.</li>
                </ol>
              </v-flex>
              <v-flex xs12>
                <b>To the best of my knowledge:</b>
              </v-flex>
              <v-radio-group v-model="member.conflict" :mandatory="false">
              <v-flex xs12>
                <v-radio value="No"></v-radio>
                <span class="body-1">I have no actual or potential conflicts to report</span>
              </v-flex>
              <v-flex xs12>
                <v-radio value="Yes"></v-radio>
                <span class="body-1">I have the following conflict of interest or potential conflict to report <i>(please specify other nonprofit and for-profit boards you
                  (or your spouse) sit on, any for-profit businesses for which you or an immediate family member are an officer or director, or a majority shareholder,
                  and the name of your employer and any businesses you or a family member own)</i></span>
              </v-flex>
              </v-radio-group>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cName1"
                  label="Name of Organization"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cPosition1"
                  label="Position Held"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cWhom1"
                  label="By Whom"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cName2"
                  label="Name of Organization"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cPosition2"
                  label="Position Held"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cWhom2"
                  label="By Whom"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cName3"
                  label="Name of Organization"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cPosition3"
                  label="Position Held"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="member.cWhom3"
                  label="By Whom"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="member.cFullName"
                  label="Full Name"
                  hint="Please type your full name to electronically sign this document"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="primary" @click="setConflict">Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data: () => ({
    currentPage: 'Settings',
    userId: 0,
    name: '',
    member: {},
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    console.log('User Id', this.user.id)
    this.userId = this.user.id
  },

  computed: {
    user () {
      return this.$store.state.user
    }
  },

  methods: {
    async setConflict () {
      try {
        this.member.name = this.name
        this.member.userId = this.userId
        this.member.cDate = moment().format('YYYY-MM-DD HH:MM:ss')

        const response = await Api().post('set_conflict', this.member)

        // console.log('res', response)
        this.$router.push({
          name: 'dashboard'
        })

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Conflict.vue